import { render } from "./vipDetailPage.vue?vue&type=template&id=651dc4a0&scoped=true"
import script from "./vipDetailPage.vue?vue&type=script&lang=js"
export * from "./vipDetailPage.vue?vue&type=script&lang=js"

import "./vipDetailPage.vue?vue&type=style&index=0&id=651dc4a0&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651dc4a0"]])

export default __exports__